import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowRight, Loader2 } from 'lucide-react';
import { cmsApi } from '../api/requests';

export default function CheckoutCancel() {
  const [cms, setCms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCms = async () => {
      try {
        const { data } = await cmsApi.getSection('checkout');
        setCms(data);
      } catch (err) {
        console.error('Failed to fetch CMS:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCms();
  }, []);

  const cp = cms?.cancelPage || {
    title: 'Payment Cancelled',
    message: "Your payment was cancelled. Don't worry - no charges were made to your account.",
    helpText: 'Need help? Contact us on Telegram for assistance with your order.',
    tryAgainButtonText: 'Try Again',
    homeButtonText: 'Back to Home'
  };

  if (loading) {
    return <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center"><Loader2 className="w-8 h-8 text-indigo-400 animate-spin" /></div>;
  }

  return (
    <div data-testid="checkout-cancel-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4 pt-24">
      <div className="max-w-lg w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-amber-500/20 rounded-full mb-8">
          <XCircle className="w-10 h-10 text-amber-400" />
        </div>

        <h1 className="text-3xl font-['Outfit'] font-medium text-white mb-4">{cp.title}</h1>
        <p className="text-zinc-400 mb-8">{cp.message}</p>

        <div className="p-6 bg-white/5 border border-white/10 rounded-xl mb-8">
          <p className="text-zinc-400 text-sm">{cp.helpText}</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/catalog" data-testid="try-again-btn"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-indigo-500 hover:bg-indigo-600 text-white font-medium rounded-lg transition-colors">
            <span>{cp.tryAgainButtonText}</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/" className="text-zinc-400 hover:text-white transition-colors">
            {cp.homeButtonText || 'Back to Home'}
          </Link>
        </div>
      </div>
    </div>
  );
}
